module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v(". . . He must be the best man in his world and a good enough man for any world. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("He is a lonely man and his pride is that you will treat him as a proud man or be very sorry you ever saw him. He talks as the man of his age talks—that is, with rude wit, a lively sense of the grotesque, a disgust for sham, and a contempt for pettiness.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Raymond Chandler")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“The Simple Art of Murder”")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("When you’re lost in the rain in Juarez and it’s Eastertime too")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("And your gravity fails and negativity don’t pull you through")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Don’t put on any airs when you’re down on Rue Morgue Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("They got some hungry women there and they really make a mess out of you.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Bob Dylan")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("Just Like Tom Thumb’s Blues")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75087d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section2.vue
// module id = 78
// module chunks = 0